import { memo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HelpOutline from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";

import { useUserStore } from "stores/UserStore";

import { authenticatedPostFetch } from "utility/authenticated_fetch";
import { clearAccessTokens, getRefreshToken } from "utility/credential_storage";
import openHelpScout from "utility/helpscout";

import Sidebar from "../Sidebar";

import HeaderLogo from "./Logo";

// -----------------------------------------------------------------------------

const Header = memo(function Header(): JSX.Element {
  const [, userActions] = useUserStore();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const openMobileMenu = () => setShowMobileMenu(true);
  const closeMobileMenu = () => setShowMobileMenu(false);

  const openAccountMenu = (event: any) => setAnchorElUser(event.currentTarget);
  const closeAccountMenu = () => setAnchorElUser(null as any);

  //
  return (
    <>
      {showMobileMenu ? (
        <Sidebar mode="mobile" onClose={closeMobileMenu} />
      ) : null}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: "#1F6BBC",
          display: "flex",
          flexDirection: "column",
          flexGrow: 0,
          flexShrink: 0,
          zIndex: 100,
        }}
      >
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            <HeaderLogo />

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={openMobileMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </Box>

            <Box sx={{ flexGrow: 1 }} />

            <Box sx={{ flexGrow: 0 }}>
              <IconButton
                size="large"
                aria-label="account settings"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={openHelpScout}
              >
                <HelpOutline />
              </IconButton>
              <Link to="/account" style={{ color: "#FFF" }}>
                <IconButton
                  size="large"
                  aria-label="account settings"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                >
                  <AccountCircleIcon />
                </IconButton>
              </Link>
              <IconButton
                size="large"
                aria-label="account settings"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={openAccountMenu}
              >
                <LogoutIcon />
              </IconButton>
              <Menu
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                sx={{ mt: "32px" }}
                open={Boolean(anchorElUser)}
                onClose={closeAccountMenu}
              >
                <Link
                  to="/login"
                  onClick={() => {
                    closeAccountMenu();
                    authenticatedPostFetch("api/auth/logoutUser", {
                      refresh_token: getRefreshToken(),
                    });
                    clearAccessTokens();
                    userActions.clear();
                    navigate("/login");
                  }}
                  style={{ color: "#000" }}
                >
                  <MenuItem>
                    <ListItemIcon sx={{ minWidth: "none" }}>
                      <LogoutIcon fontSize="small" />
                    </ListItemIcon>{" "}
                    Logout
                  </MenuItem>
                </Link>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
});

export default Header;
